import { checkRequiredAreNotEmpty } from '../lib/helpers'
import axios from 'axios'

export default{
  namespaced: true,
  state:{
    urls: {},
    leadTableColumns: [],
    sendToTypes: [],
    invalids:{
      root: [],
      json: []
    },
    current:{
      name: '',
      disabled: false,
      rules: [],
      sendToDetails: {
        company_ID: '',
        send_to_type: '',
        optional_credential_label: '',
        email_addresses: '',
        referral_code: '',
        keyword: '',
        ftp_host: '',
        ftp_user: '',
        ftp_password: '',
        ftp_filename: '',
        api_host: '',
        api_key: '',
        api_password: '',
        json_info: []
      },
      jsonData: {}
    },
    companies: [],
    companyQuery: '',
    ids: [],
    saving: false,
    loading: false,
    error: {
      error: false,
      message: '',
      code: ''
    }
  },
  mutations:{
    ERROR(state, {message, code}){
      state.error = {
        error: true,
        message: message,
        code: code
      }
    },
    RESOLVE_ERROR(state){
      state.error = {
        error: false,
        message: ''
      }
    },
    LOADING(state, bool){
      state.loading = bool
    },
    SAVING(state, bool){
      state.saving = bool
    },
    SET_URLS(state, urls){
      state.urls = urls
    },
    SET_LEAD_TABLE_COLUMNS(state, columns){
      state.leadTableColumns = columns
    },
    UPDATE_CURRENT(state, newCurrent){
      Vue.set(state, 'current', newCurrent)
      // state.current = newCurrent
    },
    UPDATE_CURRENT_SEND_TO_DETAILS(state, newSendToDetails){
      state.current.sendToDetails = newSendToDetails
    },
    UPDATE_CURRENT_SEND_TO_DETAILS_FOR_KEY(state, {key, value}){
      Vue.set(state.current.sendToDetails, key, value)
    },
    UPDATE_CURRENT_JSON_DATA_FOR_KEY(state, {key, value}){
      // Save proper booleans
      if(value === 'true') value = true
      if(value === 'false') value = false
      Vue.set(state.current.jsonData, key, value)
    },
    REMOVE_PROP_FROM_JSON_DATA(state, key){
      Vue.delete(state.current.jsonData, key)
    },
    SET_SEND_TO_TYPES(state, types){
      state.sendToTypes = types
    },
    SET_INVALIDS(state){
      const invalids = {}
      invalids.root = checkRequiredAreNotEmpty(state.current.rules, state.current.sendToDetails)
      invalids.json = checkRequiredAreNotEmpty( state.current.rules.json_info, state.current.jsonData )
      if(invalids.json.length) invalids.root.push('json_info')
      if(!state.current.sendToDetails.send_to_type)invalids.root.push('send_to_type')
      state.invalids = invalids
    },
    SET_COMPANIES(state, companies){
      state.companies = companies
    },
    SET_COMPANY_QUERY(state, query){
      state.companyQuery = query
    }
  },
  actions:{
    setCurrentConfig({state, commit}, resetJSON= true){
      commit('LOADING', true)
      axios.get(`${state.urls.sendToConfigUrl}?send_to_type=${state.current.sendToDetails.send_to_type}`)
      .then(res => {
        const maybeJSONReset = resetJSON ? { jsonData: {}} : {}
        commit('UPDATE_CURRENT', Object.assign(
          state.current,
          res.data.config,
          maybeJSONReset
        ))
        commit('LOADING', false)
      }).catch((err)=>{
        console.log(err)
        commit('LOADING', false)
      })
    },
    save({state, commit}){
      commit('SET_INVALIDS')
      if( state.invalids.root.length || state.invalids.json.length ){
        alert(`All fields for ${state.current.sendToDetails.send_to_type || 'send to details row'} not complete!` )
        return;
      }
      commit('SAVING', true)
      let data = state.current.sendToDetails;
      data.json_info = JSON.stringify(state.current.jsonData)
      
      axios.post(state.urls.submissionUrl, data)
      .then(response => {
        if(response.data.success){
          window.location = response.data.redirect
        }else{
          commit('ERROR', {
            message: `Not saved! Please refresh page and try again`,
            code: `${response.status}: ${response.statusText}`
          });
        }
      })
      .catch(error => {
        commit('SAVING', false)
        commit('ERROR', {
          message: `Not saved! Please refresh page and try again`,
          code: error
        });
      });
    },
    searchCompanies({state, commit}){
      const errMessage = 'Error searching companies'
      axios.get(`${state.urls.searchUrl}?q=${state.companyQuery}`)
      .then(res => {
        if(res.status === 200){
          state.companies = res.data.companies;
        }else{
          commit('ERROR', {
            message: errMessage,
            code: `${res.status}: ${res.statusText}`
          });
        }
        
      })
      .catch((error)=>{
        commit('ERROR', {
          message: errMessage,
          code: error
        });
      })
    },
    async generateFtp({state, commit}, client){
      try{
        const response = await axios.post(state.urls.generateFtpAccountUrl, {client})
        commit('UPDATE_CURRENT_SEND_TO_DETAILS', Object.assign({}, state.current.sendToDetails, response.data))
        return response.data;
      }catch(err){
        commit('ERROR', {
          message: 'Error generating ftp account.',
          code: err
        });
      }
    }
  }
}
